import { Button, TableCell } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { base64ToBlob, createBlobURL } from '../../../../commonFunction';

const useStyles = makeStyles((theme) => ({
  cardWrap: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '13px 8px',
    borderBottom: '1px solid #F3F3F3',
    width: '100%',
  },
  cardName: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 32,
    marginRight: 16,
    fontSize: '15px',
    fontWeight: 'bold',
    color: theme.palette.primaryColor,
    wordBreak: 'break-all',
    '& .MuiSvgIcon-root': {
      fontSize: 11,
      color: theme.palette.primaryColor,
      marginRight: 5,
    },
  },
  cardRegistrator: {
    fontSize: 13,
    textAlign: 'center',
  },
  tableTxt: {
    marginRight: '48px',
    position: 'relative',
    '&::after': {
      content: '""',
      display: 'block',
      height: '80%',
      width: '1px',
      background: '#c8c8c8',
      position: 'absolute',
      top: '50%',
      right: '-20px',
      transform: 'translate(-50%, -50%)',
    },
  },
}));

function CustomerCardItem(props) {
  const {
    card,
    getCustomerCardImage,
  } = props;

  const classes = useStyles();

  // リンクをクリックしたときに画像取得→表示
  const onClick = async () => {
    const data = await getCustomerCardImage(card.cardId);
    if (data) {
      if (/^application\/pdf/.test(data.mimeType)) {
        window.open(createBlobURL(base64ToBlob(data.base64, data.mimeType)), '_blank');
      } else {
        const newTab = window.open('', '_blank');
        newTab.document.body.innerHTML = `<img src="${createBlobURL(base64ToBlob(data.base64, data.mimeType))}" alt="顧客カード" />`;
      }
    } else {
      const newTab = window.open('', '_blank');
      newTab.document.body.innerHTML = '<p>画像の取得に失敗しました。</p>';
    }
  };

  return (
    <>
      <TableCell>
        <Typography className={`${classes.cardRegistrator}`}>
          {card.registrationDate}
        </Typography>
      </TableCell>
      <TableCell className={classes.tableTxt}>
        <Typography className={`${classes.cardRegistrator}`}>
          {card.registrator}
        </Typography>
      </TableCell>
      <TableCell>
        <Button
          variant="text"
          onClick={onClick}
          className={`${classes.cardName}`}
        >
          {card.fileName}
        </Button>
      </TableCell>
    </>
  );
}

export default CustomerCardItem;
